module.exports = __webpack_public_path__ + "img/zhongdecai.100179b8.jpg";